import React, { useState } from 'react';
import styled from '@emotion/styled';
import { Button } from '@ourliving/ourliving-ui';
import useGetSettingsListByType from '../hooks/useGetSettingsListByType';
import { L } from '../../../lib/i18n';
import useSaveSettingsListByType from '../hooks/useSaveSettingsListByType';
import SettingItem from './SettingItem';

const Container = styled.div({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: 'auto',
    flexDirection: 'column',
});
const Form = styled.form({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
});
const H1 = styled.h1({
    fontSize: '2rem',
    fontWeight: 100,
});
const Input = styled.input({
    border: '1px solid gray',
    borderRadius: '4px',
    width: '300px',
    height: '40px',
    margin: '1rem',
    paddingLeft: '1rem',
    '&:focus': {
        outline: 'none',
    },
});
const ItemContainer = styled.div({
    marginTop: '3rem',
});

type Props = {
    settingsType: 'category' | 'status' | 'unit' | 'type';
};

const Settings = ({ settingsType }: Props) => {
    const [name, setName] = useState('');
    const { data: settingsList } = useGetSettingsListByType(settingsType);
    const { mutate: save } = useSaveSettingsListByType(settingsType);

    return (
        <Container>
            <H1>{`Inställningar för ${L(settingsType)}`}</H1>
            <Form
                onSubmit={(e) => {
                    setName('');
                    e.preventDefault();
                    save({ name });
                }}
            >
                <Input
                    required={true}
                    onChange={(e) => setName(e.target.value)}
                    value={name}
                    placeholder="Skriv ditt alternativ"
                />
                <Button type="submit">{L('add')}</Button>
            </Form>
            <ItemContainer>
                {settingsList?.map((item) => {
                    return <SettingItem key={item.id} item={item} settingsType={settingsType} />;
                })}
            </ItemContainer>
        </Container>
    );
};

export default Settings;
